import styles from "./EditScreenScrollHead.module.css";
import { IoMdArrowDropdown } from "react-icons/io";
import { Link } from "react-scroll";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const EditScreenScrollHead = ({ spaceAround = false, sections }) => {
  return (
    <>
      <div
        className={styles.main_div}
        style={{
          paddingLeft: !spaceAround ? "304px" : "109px",
          paddingRight: !spaceAround ? "327px" : "130px",
        }}
      >
        {Array.isArray(sections) &&
          sections.length > 0 &&
          sections.map((item, index) => {
            return (
              <div key={index} className={styles.single_item}>
                <Link
                  to={item}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                >
                  <div className={styles.text}>{item}</div>
                </Link>
                <Link
                  to={item}
                  spy={true}
                  smooth={true}
                  offset={-100}
                  duration={500}
                >
                  <IoMdArrowDropdown
                    size={32}
                    className={styles.icon}
                  ></IoMdArrowDropdown>
                </Link>

                {/* <i class="fa-solid fa-caret-down"></i>
              <FontAwesomeIcon icon="fa-solid fa-caret-down" /> */}
              </div>
            );
          })}
      </div>
    </>
  );
};
export default EditScreenScrollHead;
